export default __webpack_public_path__ + "static/media/ilustracao-homem-comemorando-sorteio.cc83355b.svg";